/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./boost.vue?vue&type=template&id=96838760&scoped=true"
import script from "./boost.vue?vue&type=script&lang=js"
export * from "./boost.vue?vue&type=script&lang=js"
import style0 from "./boost.vue?vue&type=style&index=0&id=96838760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96838760",
  null
  
)

export default component.exports